module.exports = __webpack_public_path__ + "static/img/map3_relation.1820f7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/map3_relation.jpg
// module id = vUzK
// module chunks = 1